import { render } from "./wo-content-editable.vue?vue&type=template&id=1bc15c40&scoped=true"
import script from "./wo-content-editable.vue?vue&type=script&lang=js"
export * from "./wo-content-editable.vue?vue&type=script&lang=js"

import "./wo-content-editable.vue?vue&type=style&index=0&id=1bc15c40&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc15c40"]])

export default __exports__